import React, { useState } from 'react';
import { func } from 'prop-types';

const SearchPanel = ({ onUpdateSearch }) => {
  const [, setSearchTerm] = useState('')

  const updateSearch = ({ target: { value } }) => {
    const term = value.trim()

    setSearchTerm(term)
    onUpdateSearch(term)
  }

  return (
    <input
      className="form-control search-input"
      type="text"
      placeholder="Поиск..."
      onChange={event => updateSearch(event)}
    />
  )
}

SearchPanel.propTypes = {
  onUpdateSearch: func,
}
SearchPanel.defaultProps = {
  onUpdateSearch: () => { },
}

export default SearchPanel